import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageReviewer } from '@/api/model/interfaces';

export default class DrawingPackageReviewerOdata extends OdataManager<DrawingPackageReviewer> {}
